export default "__VITE_ASSET__Bc279kF4__"